import Cookies from 'js-cookie';
import { Modal } from 'antd';
import timezones from 'timezones-list';

class Data {
    // static url = "https://api.sb-dt.com";
    static url = "http://localhost:3000";

    static authCookieValue = Cookies.get('authCookie');

    static userData = {};

    static async fetchLogin(email, password) {
        try {
            const response = await fetch(`${Data.url}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "email": email,
                    "password": password
                })
            });
            const data = await response.json();
            if (!response.ok) {
                // handle server-side error
                return data.error;
            } else {
                // handle successful login
                Cookies.set('authCookie', data.token);
                localStorage.setItem('userType', 'customer');
                this.authCookieValue = data.token;
                this.fetchUser();

                return data;
            }
        } catch (error) {
            console.error('Failed to fetch:', error);
            this.showErrorModal('Failed to fetch:' + error);
        }
    }

    static async fetchUser() {
        try {
            const response = await fetch(`${Data.url}/user`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${this.authCookieValue}`,
                }
            });
            const data = await response.json();
            // console.log(response.status);
            
            if (!response.ok) {
                if (response.status === 401) {
                    this.logout();
                }

                return data.error;
            } else {
                return data;
            }
        } catch (error) {
            console.error('Failed to fetch:', error);
        }
    }

    static async logout() {
        document.cookie = "authCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = '/';
    }

    //Fetch sign up page
    static async fetchSignUp(firstName, lastName, email, password, passwordAgain, country, type, birthday) {
        const user = `firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}&passwordAgain=${encodeURIComponent(passwordAgain)}&country=${encodeURIComponent(country)}&type=${encodeURIComponent(type)}&birthday=${encodeURIComponent(birthday)}`;

        try {
            const response = await fetch(`${Data.url}/registration`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: user
            });

            const data = await response.json();

            if (!response.ok) {
                // handle server-side error
                return data.error ? data.error : data;
            }

        } catch (error) {
            console.error('Failed to fetch:', error);
        }
    }

    static async fetchUploadAvatar(file) {
        try {
            const formData = new FormData();
            formData.append('avatar', file);

            const response = await fetch(`${Data.url}/user`, {
                method: 'PUT',
                headers: {
                    Authorization: `${this.authCookieValue}`,
                },
                body: formData,
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error);
            }

            return response.json();
        } catch (error) {
            console.error('Error uploading avatar:', error);
            throw error;
        }
    }

    static async fetchChangePassword(oldPassword, newPassword, newPasswordAgain) {
        try {
            const response = await fetch(`${Data.url}/user/password`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${this.authCookieValue}`,
                },
                body: JSON.stringify({
                    "oldPassword": oldPassword,
                    "newPassword": newPassword,
                    "newPasswordAgain": newPasswordAgain
                })
            });
            const data = await response.json();
            if (!response.ok) {
                return data.error;
            }

        } catch (error) {
            console.error('Failed to fetch:', error);
        }
    }

    //Fetch change password page
    static async fetchChangeForgotPassword(request, newPassword, newPasswordAgain) {
        const body = `requestId=${encodeURIComponent(request)}&password=${encodeURIComponent(newPassword)}&passwordAgain=${encodeURIComponent(newPasswordAgain)}`;

        try {
            const response = await fetch(`${Data.url}/change-password`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body
            });

            const data = await response.json();
            if (!response.ok) {
                return data.error;
            }

        } catch (error) {
            console.error('Failed to fetch:', error);
        }
    }

    //Fetch forgot password page
    static async fetchForgotPassword(email) {
        const body = `email=${encodeURIComponent(email)}`;

        try {
            const response = await fetch(`${Data.url}/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body
            });

            const data = await response.json();
            if (!response.ok) {
                return data.error;
            }

        } catch (error) {
            console.error('Failed to fetch:', error);
        }
    }

    static async fetchDesigners() {
        const response = await fetch(`${Data.url}/designers`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        const res = await response.json();

        if (!res) {

            await Promise.all(
                res.map(async (designer) => {
                    const countryData = await this.fetchCountries(designer.country);
                    designer.cca2 = designer.country;
                    designer.country = countryData.name.common;
                    return designer;
                })
            );
        }

        return res;
    }

    static async fetchDesigner(id) {
        const response = await fetch(`${Data.url}/designers/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        const res = await response.json();
        return res;
    }

    static async fetchProjects() {
        const response = await fetch(`${Data.url}/projects`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `${this.authCookieValue}`,
                'type': Data.getUserType()
            }
        });

        return await response.json();
    }

    static async fetchProjectById(id) {
        const response = await fetch(`${Data.url}/projects/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `${this.authCookieValue}`,
            },
        });

        return await response.json();
    }

    static async createProject(json) {
        
        const response = await fetch(`${Data.url}/projects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            },
            body: json
        });

        if (!response.ok) {
            //console.log(response);
            // throw new Error(`HTTP error! ${data.error ? response.error : response.status}`);
            throw new Error("Something went wrong");
        }

        return await response.json();
    }

    static async modifyProject(id, data) {
        const response = await fetch(`${Data.url}/projects/${id}`, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                Authorization: `${this.authCookieValue}`,
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error("Something went wrong");
        }

        return await response.json();
    }

    static async setArchive(id) {
        try {
            await fetch(`${Data.url}/projects/${id}/archive`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${this.authCookieValue}`,
                },
            });

            return;
        } catch (e) { }
    }

    static async fetchNotifications() {
        const response = await fetch(`${Data.url}/notifications`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `${this.authCookieValue}`,
            },
        });

        var res = await response.json();
        const sortedNotifications = res.sort((a, b) => {
            if (a.readAt === null && b.readAt !== null) {
                return -1;
            } else if (a.readAt !== null && b.readAt === null) {
                return 1;
            } else {
                return new Date(b.createdAt) - new Date(a.createdAt);
            }
        });

        return sortedNotifications;
    }

    static async updateReadNotification(id) {
        try {
            await fetch(`${Data.url}/notifications/${id}/read`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${this.authCookieValue}`,
                },
            });

            return;
        } catch (e) { }
    }

    static async fetchVerification(token) {
        const response = await fetch(`${Data.url}/account-verification/${token}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `${this.authCookieValue}`,
            }
        });

        if (!response.ok)
            throw new Error();

        return;
    }

    static async sendVerification(email) {
        const response = await fetch(`${Data.url}/send-verification`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                'email': email
            })
        });

        if (!response.ok)
            throw new Error();

        return;
    }

    static async fetchCountries(cca2) {
        try {
            if (cca2 !== undefined) {
                const response = await fetch(`https://restcountries.com/v3.1/alpha/codes=${cca2}?fields=name,cca2`);
                return await response.json();
            }

            const response = await fetch('https://restcountries.com/v3.1/all?fields=name,cca2');
            const data = await response.json();
            const sortedCountries = data.sort((a, b) =>
                a.name.common.localeCompare(b.name.common)
            );

            return sortedCountries;
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    static fetchTimeZones() {
        return timezones.map(tz => ({
            timeZone: tz.tzCode,
            offset: tz.utc
        }));
    }

    static async addReference(reference) {
        const response = await fetch(`${Data.url}/references/new`, {
            method: 'POST',
            headers: {
                Authorization: `${this.authCookieValue}`,
            },
            body: reference,
        });

        if (!response.ok) {
            const data = await response.json();
            if (data.error === "SERVICE_EXISTS")
                throw new Error("Service already exists");
            else
                throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    static async deleteReference(name) {
        const response = await fetch(`${Data.url}/references/${name}/remove`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    static async updateService(service) {
        const response = await fetch(`${Data.url}/service/${service.getAll('id')[0]}`, {
            method: 'PUT',
            headers: {
                Authorization: `${this.authCookieValue}`,
            },
            body: service,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    static async fetchUsers() {
        const response = await fetch(`${Data.url}/users`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            }
        });

        if (!response.ok) {
            return;
        }

        const res = await response.json();

        await Promise.all(
            res.map(async (user) => {
                try {
                    const countryData = await this.fetchCountries(user.country);
                    user.cca2 = user.country;
                    user.country = countryData.name.common;
                } catch {
                    user.cca2 = '';
                }
                return user;
            })
        );

        return res;
    }

    static async deleteUser(id) {
        const response = await fetch(`${Data.url}/users/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    static async showErrorModal(errorMessage) {
        const errorModal = Modal.error({
            title: 'Error',
            content: errorMessage,
            onOk() {
                errorModal.destroy();
                window.location.reload();
            }
        });

        setTimeout(() => {
            errorModal.destroy();
        }, 3000);

        return errorModal;
    }

    static async updateCrownPrice(crownPrice) {
        const response = await fetch(`${Data.url}/designers/crown-price`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            },
            body: JSON.stringify({ crownPrice })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }
    
    static async updateProjectPrice(projectPrice) {
        const response = await fetch(`${Data.url}/designers/project-price`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${this.authCookieValue}`,
            },
            body: JSON.stringify({ projectPrice })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    }

    static changeUserType() {
        const userType = localStorage.getItem('userType');
        localStorage.setItem('userType', userType === 'designer' ? 'customer' : 'designer');
        window.location.reload();
    }

    static getUserType() {
        return localStorage.getItem('userType');
    }
}

export default Data;
